/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography, Typography2, useTheme } from '@coursera/cds-core';
import { CheckIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/teams-v2';

function ValuePropItem({ text }: { text: JSX.Element }) {
  const theme = useTheme();
  return (
    <div css={{ display: 'flex', marginBottom: theme.spacing(8) }}>
      <div css={{ width: 16, paddingTop: 2 }}>
        <CheckIcon color="interactive" size="small" />
      </div>
      <Typography2 component="p" css={{ marginLeft: theme.spacing(16) }}>
        {text}
      </Typography2>
    </div>
  );
}

function TeamsFreeTrialPropItem() {
  const theme = useTheme();
  return (
    <div css={{ marginTop: theme.spacing(16), padding: `${theme.spacing(16)} ${theme.spacing(24)}` }}>
      <Typography variant="h2">{_t('What’s included in the free trial?')}</Typography>

      <ValuePropItem
        text={
          <FormattedMessage
            message={_t('{highlightText} get unlimited access to the full Coursera catalog')}
            highlightText={<strong>{_t('5 users')}</strong>}
          />
        }
      />
      <ValuePropItem
        text={
          <FormattedMessage
            message={_t('{highlightText} content recommendations')}
            highlightText={<strong>{_t('Personalized')}</strong>}
          />
        }
      />
      <ValuePropItem
        text={
          <FormattedMessage
            message={_t('Learner {highlightText}')}
            highlightText={<strong>{_t('usage and progress tracking tools')}</strong>}
          />
        }
      />
      <ValuePropItem
        text={
          <FormattedMessage
            message={_t('{highlightText} credentials')}
            highlightText={<strong>{_t('Industry-recognized')}</strong>}
          />
        }
      />
    </div>
  );
}

export default TeamsFreeTrialPropItem;
